/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { networkGetNetworkPing } from "../../funcs/networkGetNetworkPing.js";
import { GetNetworkPingRequest$zodSchema } from "../../models/getnetworkpingop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetNetworkPingRequest$zodSchema,
};

export const tool$networkGetNetworkPing: ToolDefinition<typeof args> = {
  name: "network-get-network-ping",
  description: `Ping 主机

想知道从我们的服务器到你的服务器网络延迟高不高？这个工具可以帮你测试网络连通性。

## 功能概述
这个接口会从我们的服务器节点对你指定的主机（域名或IP地址）执行 ICMP Ping 操作。它会返回最小、最大、平均延迟以及丢包率等关键指标，是诊断网络问题的得力助手。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await networkGetNetworkPing(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
